import {RiveLoad} from "parts";
import {useEffect, useState} from "react";
import {useRivePreload} from "utils";

export function RiveFetch({
  src, className, style: st, width, height, show = true,  toLoad = true, image,
  locale = false, module = false, ...props
}) {
  const
    {path, blobUrl, setBlobUrl} = useRivePreload({src, locale, module}),
    // [showRive, setShowRive] = useState(show),
    [showRive] = useState(true),
    [load, setLoad] = useState(toLoad && !blobUrl && (!path.startsWith('blob:') || image))

  // useEffect(() => {
  //   // FIXME: wait for rive
  //   setTimeout(() => setShowRive(true), 500)
  //   // const id = requestAnimationFrame(() => setShowRive(true))
  //   // return () => cancelAnimationFrame(id)
  // }, [])

  useEffect(() => {
    if (blobUrl)
      return

    let canceled = false

    fetch(path, {
      cache: 'force-cache'
    })
      .then(r => r.blob())
      .then(blob => {
        if (!canceled) {
          setBlobUrl(URL.createObjectURL(blob))
          setTimeout(() => setLoad(false), 25)
        }
      })

    return () => {
      canceled = true
    }
  }, [])

  const style = {aspectRatio: width / height, ...st}

  if (load && image)
    style.backgroundImage = `url(${image})`

  // const {fetch, ...rest} = props

  return (
    <div className={className + (load ? ` load${image ? '-image' : ''}` : '')} style={style}>
      {
        blobUrl && showRive &&
        <RiveLoad key={src} width={width} height={height} src={blobUrl} toLoad={toLoad} image={image}
                  {...props}
        />
      }
    </div>
  )
}